import { useState } from "react";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const r = await api.post("/subscribe", { email });
      toast.success(r.data?.message || "You're on the list — thank you!");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="border-t border-border bg-linen" data-testid="newsletter">
      <div className="mx-auto max-w-3xl px-6 py-20 text-center">
        <div className="overline mb-4 flex items-center justify-center gap-2"><Mail size={14} className="text-clay" /> The Journal, in your inbox</div>
        <h2 className="font-serif text-3xl text-ink sm:text-4xl">Gentle notes on healing, <span className="italic text-clay">delivered.</span></h2>
        <p className="mx-auto mt-4 max-w-md font-sans text-sm leading-relaxed text-ink-soft">New articles on therapy, anxiety and wellbeing — no spam, unsubscribe anytime.</p>
        <form onSubmit={submit} className="mx-auto mt-8 flex max-w-md flex-col gap-3 sm:flex-row">
          <input
            data-testid="newsletter-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            className="flex-1 rounded-full border border-border bg-white px-5 py-3 font-sans text-sm text-ink outline-none transition-colors focus:border-clay"
          />
          <button
            data-testid="newsletter-submit"
            disabled={busy}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-3 font-sans text-sm text-linen transition-colors hover:bg-ink/85 disabled:opacity-60"
          >
            {busy ? <Loader2 size={15} className="animate-spin" /> : null} Subscribe
          </button>
        </form>
      </div>
    </section>
  );
};
